

const atencionImagenesLS = localStorage.getItem('atencionImagenes')
  ? JSON.parse(localStorage.getItem('atencionImagenes'))
  : [];


export default {
  state:{
    imagenesList: atencionImagenesLS,
  },

  
  mutations: {

    setImagenesList( state, data) {
      state.imagenesList = data
    },

    resetImagenes( state ) {
      state.imagenesList = []
    }
  }
}
  